import { getAbTestTrackingData } from 'dibs-buyer-layout/exports/clientABTestHelpers';
import tracking from 'dibs-tracking';
import { VisitCountModel } from 'dibs-visit-tracking/exports/visitCountModel';
import { getEverLoggedIn } from 'dibs-cookie-jar';
import throttle from 'lodash.throttle';
import { gaLabels } from '../authModal/postAuth/constants';
import { autoPromptRegistration } from '../notificationQueue/globalNotifications/helpers/postAuthLoader';
import { PAGEVIEW_LIMIT_FLOW } from '../authModal/authentication/authFlowConstants';
import { PAGE_TYPE, BROWSE_TYPES } from '../utils/pageConstants';

const REGISTRATION_TRIGGER = 'REGISTRATION_TRIGGER';
const AUTH_MODAL_SHOWN = 'authModalShown';
const PAGE_TYPE_SB = [...BROWSE_TYPES, PAGE_TYPE.SEARCH];

const fireRegistrationTriggerABTestTracking = (eventLabel: string): void => {
    const action = `registration_${eventLabel}`;
    const trackingData = getAbTestTrackingData(
        document.cookie,
        REGISTRATION_TRIGGER,
        eventLabel.toUpperCase()
    );
    tracking.trackAbTestEvent(trackingData, action);
};

const shouldFireRegistrationTriggerTestTracking = (): boolean => {
    const visitCountModel = new VisitCountModel();
    return (
        visitCountModel.get('totalVisitCount') === visitCountModel.get('sbPromptLimit') &&
        !getEverLoggedIn(document.cookie)
    );
};

let throttledScroll: EventListener = () => {};

const handleScroll = (): void => {
    const resultsContainer = document.getElementById('sb-results-container');
    if (!resultsContainer) {
        window.removeEventListener('scroll', throttledScroll);
        return;
    }
    if (
        window.scrollY >= resultsContainer.clientHeight / 2 &&
        !sessionStorage.getItem(AUTH_MODAL_SHOWN)
    ) {
        const flow = PAGEVIEW_LIMIT_FLOW;
        const ga = {
            label: gaLabels.PAGEVIEW_LIMIT_REACHED,
        };
        autoPromptRegistration({ flow, launchOrigin: ga.label });
        fireRegistrationTriggerABTestTracking('modal_display');
        sessionStorage.setItem(AUTH_MODAL_SHOWN, 'shown');
        if (throttledScroll) {
            window.removeEventListener('scroll', throttledScroll);
        }
    }
};

throttledScroll = throttle(handleScroll, 100);

export {
    fireRegistrationTriggerABTestTracking,
    shouldFireRegistrationTriggerTestTracking,
    throttledScroll,
    AUTH_MODAL_SHOWN,
    REGISTRATION_TRIGGER,
    PAGE_TYPE_SB,
};
